<template>
  <v-container>
    <v-card>
      <v-card-text>
        <v-container>
          <v-layout d-block>
            <v-flex>
              <v-btn
                large
                block
                @click="showOverdue = ! showOverdue"
              >Nog af te ronden ({{ addressesOverdue.length }})</v-btn>
              <address-list-pageable :addresses="addressesOverdue" v-if="showOverdue" show-date></address-list-pageable>
            </v-flex>
            <v-flex>
              <v-btn
                large
                block
                @click="showToday = !showToday"
              >Afspraken vandaag ({{ addressesToday.length }})</v-btn>
              <address-list-pageable :addresses="addressesToday" v-if="showToday" show-time></address-list-pageable>
            </v-flex>
            <v-flex>
              <v-btn
                large
                block
                @click="showTomorrow = !showTomorrow"
              >Afspraken morgen ({{ addressesTomorrow.length }})</v-btn>
              <address-list-pageable :addresses="addressesTomorrow" v-if="showTomorrow" show-time></address-list-pageable>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { assignmentService } from "@/services/mechanic";
import AddressListPageable from "@/components/AddressListPageable";

export default {
  name: "worklistMechanic",
  components: { AddressListPageable },

  data: () => ({
    addressesOverdue: [],
    addressesToday: [],
    addressesTomorrow: [],
    showOverdue: false,
    showToday: false,
    showTomorrow: false
  }),
  methods: {
    loadAddressesInitial(assignmentId) {
      this.pagination.page = 0;
      this.pagination.pages = 0;
      this.loadAddresses(assignmentId);
    },
    loadAddresses() {
      // Query today
      assignmentService
        .resolveAllMechanic()
        .then(result => {
          this.addressesToday = result.data.visitsToday;
          this.addressesTomorrow = result.data.visitsTomorrow;
          this.addressesOverdue = result.data.visitsOverdue;
        })
        // eslint-disable-next-line
        .catch(() => console.log("Error!"));
    }
  },
  created() {
    this.loadAddresses();
  }
};
</script>
